import React from 'react';
import { useParams } from 'react-router-dom';

import { OfferConfigurePageContainer } from '@occc-app/offerHelpers/components/OfferConfigurePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';
import { useChainId } from '@occc-app/Chain/hooks';
import { GameConfigureFormContainer } from '@occc-app/routes/Game/GameConfigureForm/GameConfigureFormContainer';
import { getCreatePageLinks as getCreateProgramManagementPageLinks } from '@occc-app/routes/ProgramManagement/utils';
import {
  getCreatePageLinks as getCreateCampaignManagementPageLinks,
  useGetCampaignName,
} from '@occc-app/routes/CampaignComponents/utils';

import { messages } from '../messages';

type CampaignManagementGameConfigureParams = {
  id: string;
  gameId: string;
};

export const CampaignManagementGameConfigurePageContainer = () => {
  const { id: campaignId = '', gameId = '' } = useParams<CampaignManagementGameConfigureParams>();
  const chainId = useChainId();
  const campaignName = useGetCampaignName(chainId, campaignId);

  return (
    <OfferConfigurePageContainer
      campaignId={campaignId}
      offerId={gameId}
      getBreadcrumbLinks={(offerName) =>
        getCreateCampaignManagementPageLinks(campaignId, campaignName, offerName)
      }
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.FreeGame}
      showExternalUrl
      ignoreConfigureFormSubmit
      ConfigureFormContainer={GameConfigureFormContainer}
    />
  );
};

type ProgramManagementGameConfigureParams = {
  offerId: string;
};
export const ProgramManagementGameConfigurePageContainer = () => {
  const { offerId = '' } = useParams<ProgramManagementGameConfigureParams>();

  return (
    <OfferConfigurePageContainer
      offerId={offerId}
      getBreadcrumbLinks={() =>
        getCreateProgramManagementPageLinks(messages.configurePageTitle, OfferType.VoucheredGame)
      }
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.VoucheredGame}
      ConfigureFormContainer={GameConfigureFormContainer}
      showSurgeonGeneralsWarning={false}
    />
  );
};
